import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  REPORTS_MANAGEMENT(state, reports_management) {
    state.cached = reports_management
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchReportManagement(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/euro_habeas_data/report/${query}`).then((response) => {
      const request = response.data
      context.commit('REPORTS_MANAGEMENT', request)
      return request
    })
  },
  fetchReportManagementExcel(context, payload) {
    // query = query || ''
    return axios.get(`${serverUrl}/euro_habeas_data/report/${payload.query}`, payload.type).then((response) => {
      if (payload.type) {
        return response
      }
      const request = response.data
      return request
    })
  },

  fetchCashOptions(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/euro_captacion/options_cash/${query}`)
      .then((response) => {
        return response.data
      })
  },

  fetchCoOptions(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/euro_captacion/options_co/${query}`)
      .then((response) => {
        return response.data
      })
  },

  fetchCashRegisterOptions(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/euro_captacion/options_casher_register/${query}`)
      .then((response) => {
        return response.data
      })
  },

}